var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.419 9.95c0-2.297.792-6.908 6.197-8.636A9.835 9.835 0 0 0 3.89 4.82a9.496 9.496 0 0 0-1.408 4.857l2.054-.356a5.595 5.595 0 0 0 3.135-1.79A5.336 5.336 0 0 0 9 4.236V0L4.578.754a5.876 5.876 0 0 0-3.241 1.934A5.607 5.607 0 0 0 0 6.153v8.703c.47.079.943.127 1.419.144V9.95Z",
    fill: "#BCBCAF"
  })));
};
export default SvgLeaf;